// A task row's height and where it comes from: the cells' top and bottom padding around one 18 px line of text, plus
// their 1 px borders. The list positions rows (and its sticky headers) by this height, so the cells must add up to it.
export const CELL_LINE_HEIGHT = 18;
// The values in a row (the title is 13 px).
export const CELL_FONT_SIZE = 12.5;
export const CELL_PADDING_Y = 12;
export const TASK_ROW_HEIGHT = CELL_LINE_HEIGHT + 2 * CELL_PADDING_Y + 2;

// Above a group's rows: the course name (when the list shows several courses), the group's pill and its column labels.
export const COURSE_TITLE_HEIGHT = 61;
export const GROUP_HEADER_HEIGHT = 39;
export const COLUMN_LABELS_HEIGHT = 34;
// The add row opened with a group pill's "+", under the group's labels: its 38 px and a little air below.
export const TOP_ADD_ROW_HEIGHT = 50;
/** An open add row on one line. On a narrow window its chips wrap and it grows; the list then gives it the difference. */
export const ADD_ROW_ONE_LINE = 38;
/** The add row opened from a group pill's "+" is named after its group with this in front. */
export const TOP_ADD_PREFIX = 'top:';
/** The add row opened next to a course's name (All tasks, by category or reading source): this and the course's id. */
export const COURSE_ADD_PREFIX = 'course:';
